angular.module('ApiUtils.dms.cropData').factory('CropVarietyList', function ($resource){
    return $resource('/api/v1.0/fieldplotcrop/cropvarietylist/');
});
